import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $copyLinkButtons = $('.copy-link');

    function setTempMessage($el, text, containerClass) {
        $el.text(text);
        $el.parent().addClass(containerClass);
        setTimeout(() => {
            $el.text(null);
            $el.parent().removeClass(containerClass);
            $el.blur();
        }, 2500);
    }

    $copyLinkButtons.each(function () {
        const $link = $(this),
            $textEl = $link.find('span');

        $link.on('click', function () {
            if ('clipboard' in navigator) {
                navigator.clipboard
                    .writeText($link.data('link'))
                    .then(() => {
                        setTempMessage($textEl, 'Copied!', 'success');
                    })
                    .catch((err) => {
                        console.error(err.name, err.message);
                        setTempMessage($textEl, 'Copy Failed', 'error');
                    });
            } else {
                const $textarea = $(
                    '<textarea style="position: absolute; opacity: 0;">' +
                        $link.data('link') +
                        '</textarea>',
                );
                $link.closest('.wrapper').append($textarea);
                $textarea.focus();
                $textarea.select();
                try {
                    const success = document.execCommand('copy');
                    if (success) {
                        setTempMessage($textEl, 'Copied!', 'success');
                    } else {
                        setTempMessage($textEl, 'Copy Failed', 'error');
                    }
                } catch (err) {
                    console.error(err.name, err.message);
                    setTempMessage($textEl, 'Copy Failed', 'error');
                }
                $textarea.remove();
            }
        });
    });
});
